<template>
<div>
    <Select
        ref="merchant"
        @on-change="setMerchantId"
        v-model="searchWord"
        filterable
        remote
        :remote-method="remoteMethod"
        :loading="loading"
        :clearable="true"
        :placeholder="placeholder">
        <Option v-for="(option, index) in options" :value="option.id" :key="index">{{option.uname}}</Option>
    </Select>
</div>
</template>
<script>
/**
 * 输入关键词搜索商家
 * @param merchantId Number 选中的商家ID
 */
import common from '@/common/common.js'
    export default {
        props:{
            merchantId:Number,
            placeholder:{
                type:String,
                default:'输入手机号搜索'
            }
        },
        data () {
            return {
                searchWord:'',
                loading: false,
                options: [],
            }
        },
        methods: {
            remoteMethod (query) {//请求数据
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        let getData = {params:{keyWord:query}}
                        this.axios.get(this.config.urlArray.searchMerchant,getData).then((result) => {
                            common.ajaxMsg(result.data,false,()=>{
                                this.options = result.data.data.data.list
                            },()=>{},false)
                        }).catch((err) => {
                            common.msg('error','商家搜索出错',()=>{})
                        });

                    }, 260);
                } else {
                    this.options = [];
                }
            },
            getMerchantInfo (id) {//编辑时付默认值的方法
                    let getData = {params:{merchantId:id}}
                    this.axios.get(this.config.urlArray.searchOneMerchant,getData).then((result) => {
                        common.ajaxMsg(result.data,false,()=>{
                            this.$refs.merchant.setQuery(result.data.data.uname)
                        },()=>{},false)
                    }).catch((err) => {
                        common.msg('error','商家搜索出错',()=>{})
                    });
            },
            clearAll () {//清空
                this.$refs.merchant.clearSingleSelect()
            },
            setMerchantId (value) {//更新父组件的值
               this.$emit('update:merchantId',value)
            },
        },
        mounted () {
        }
    }
</script>
